export enum TagKeys {
  Support = 'nuvempago_config_support_click',
  BankingAccountEdit = 'nuvempago_config_banking_account_edit_click',
  PaymentMethodsCard = 'nuvempago_config_payment_method',
  DeadlineReceiptCard = 'nuvempago_config_deadline_receipt',
  InstallmentCard = 'nuvempago_config_installment',
  DiscountCard = 'nuvempago_config_discount',
  QrCodePixCard = 'nuvempago_config_qrcodepix',
  AddBankAccount = 'nuvempago_config_add_banking_account',
  PaymentsMethhodsSave = 'nuvempago_config_payments_types_save',
  PayoutCreditOptionSelect = 'nuvempago_config_payout_credit_option_select',
  PayoutPixOptionSelect = 'nuvempago_config_payout_pix_option_select',
  PayoutBoletoOptionSelect = 'nuvempago_config_payout_boleto_option_select',
  PayoutSave = 'nuvempago_config_payout_save_click',
  InstallmentsClickSave = 'nuvempago_config_installments_click_save',
  InstallmentsSelectInterest = 'nuvempago_config_installments_select_interest',
  InstallmentsInputMinValue = 'nuvempago_config_installments_input_min_value',
  QrCodePixSave = 'nuvempago_qr_code_pix_click_save',
  QrCodePixSelect = 'nuvempago_qr_code_pix_select',
  QrCodePixToggle = 'nuvempago_qr_code_pix_toggle',
  SettingsRetryClick = 'nuvempago_settings_retry_click',
  settingsPageView = 'nuvempago_config_page_view',
  configureNuvemPagoActivation = 'nuvempago_config_nuvempago_activation',
  configPayoutAlertCreditCardActiveClick = 'nuvempago_config_payout_alert_credit_card_active',
  configPayoutAlertPixActiveClick = 'nuvempago_config_payout_alert_pix_active',
  configInstallmentsAlertCreditCardActive = 'nuvempago_config_installments_alert_credit_card_active',
  qrCodePixAlertPixActive = 'nuvempago_qr_code_pix_alert_pix_active',
  configDiscountAlertPixActive = 'nuvempago_config_discount_alert_pix_active',
  configDiscountAlertBankSlipActive = 'nuvempago_config_discount_alert_bank_slip_active',
}
